export const PageEventsTypes = {
  OlympHomeAppear: "OlympHomeAppear",
  OlympLoginClick: "OlympLoginClick",
  OlympSignUpClick: "OlympSignUpClick",
  OlympBackClick: "OlympBackClick",
  OlympTasksTryClick: "OlympTasksTryClick",
  OlympTasksGradeClick: "OlympTasksGradeClick",
  OlympReportsClassClick: "OlympReportsClassClick",
  OlympDownloadPosterClick: "OlympDownloadPosterClick",
  OlympTaskClick: "OlympTaskClick",
  OlympTaskRetryClick: "OlympTaskRetryClick",
  OlympAllTasksSolvedAppear: "OlympAllTasksSolvedAppear",
}
